import { ativoPath } from '@/libs/ativo-route';

export const reportPathForTicker = (tickerLabel: string) => ativoPath.tab(tickerLabel, 'relatorios');

export const shouldRenderReportActions = (g2rsMode: boolean) => !g2rsMode;
